export default __webpack_public_path__ + "static/media/mac_3.43f9bab7.webp";